import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import { watchStreckeSnapshot } from './streckeSnapshotSaga';
import { watchStateSnapshot } from './stateSnapshotSaga';
import { watchProduktlinienSaga } from './produktlinienSaga';
import { watchInDashboardUebernehmenSaga } from './inDashboardUebernehmenSaga';
import { streckenTarifierungTkv } from './streckenTarifierungTkv';
import { shopTarifierungTkv } from './shopTarifierungTkv';
import { watchAntragsnummerRequested } from './antragsnummerSaga';
import { watchVorbelegungRequested } from './vorbelegungSaga';
import { watchVorschlagdatenChangend } from './vorschlagdatenSaga';
import { watchDruckdatenChanged } from './druckdatenSaga';
import { watchQuoteDB } from './quoteDbSaga';
import { handleTkvNavigationToAngebotSaga } from './handleTkvNavigationToAngebotSaga';

export function* rootSaga() {
  yield all([
    watchStreckeSnapshot(),
    watchStateSnapshot(),
    watchProduktlinienSaga(),
    watchInDashboardUebernehmenSaga(),
    watchProduktlinienSaga(),
    streckenTarifierungTkv(),
    shopTarifierungTkv(),
    watchAntragsnummerRequested(),
    watchVorschlagdatenChangend(),
    watchDruckdatenChanged(),
    watchQuoteDB(),
    watchVorbelegungRequested(),
    handleTkvNavigationToAngebotSaga(),
  ]);
}
